<div *ngIf="showModal" class="modal-container fixed inset-0 z-50 bg-gray-900 bg-opacity-50 flex justify-center items-center overflow-y-auto p-4">
  <div class="modal-content bg-black dark:bg-white p-6 text-white dark:text-black w-full sm:w-11/12 md:w-3/4 lg:w-1/2 xl:w-1/3 max-w-2xl rounded-lg shadow-lg">
    <!-- <h2 class="text-center text-3xl font-bold text-white dark:text-black pb-4">
      <img src="../../../../../../assets/images/register-vehicle.gif" alt="">
    </h2> -->
    <h1 class="text-center text-3xl font-bold text-white dark:text-black">Editar Vehículo 🚗🏍️</h1>
    
    <form [formGroup]="vehicleForm" (ngSubmit)="updateVehicle()">
      <div class="flex flex-wrap md:flex-nowrap gap-4 mb-4">
        <select type="text" formControlName="typevehicle" class="form-input ltr:pl-10 rtl:pr-10">
          <option value="" disabled selected>Selecciona el tipo de vehiculo</option>
          <option *ngFor="let vehicle of listVehicleTypesAll" [value]="vehicle._id">{{ vehicle.name }}</option>
        </select>
        <div *ngIf="vehicleForm.get('typevehicle')?.invalid && vehicleForm.get('typevehicle')?.touched" class="text-red-500">
          <small *ngIf="vehicleForm.get('typevehicle')?.errors?.['required']"> Ingresa tipo de vehiculo </small>
        </div>
      </div>

      <div class="flex flex-wrap md:flex-nowrap gap-4 mb-4">
        <div class="half w-full md:w-1/2">
          <input type="text" formControlName="brand" placeholder="Marca" class="form-input ltr:pl-10 rtl:pr-10" />
          <div *ngIf="vehicleForm.get('brand')?.invalid && vehicleForm.get('brand')?.touched" class="text-red-500">
            <small *ngIf="vehicleForm.get('brand')?.errors?.['required']"> Ingresa la marca </small>
          </div>
        </div>

        <div class="half w-full md:w-1/2">
          <input type="text" formControlName="modelo" placeholder="Modelo" class="form-input ltr:pl-10 rtl:pr-10" />
          <div *ngIf="vehicleForm.get('modelo')?.invalid && vehicleForm.get('modelo')?.touched" class="text-red-500">
            <small *ngIf="vehicleForm.get('modelo')?.errors?.['required']"> Ingresa el modelo </small>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap md:flex-nowrap gap-4">
        <div class="half w-full md:w-1/2">
          <input type="number" formControlName="km" placeholder="Kilometraje" class="form-input ltr:pl-10 rtl:pr-10" />
          <div *ngIf="vehicleForm.get('km')?.invalid && vehicleForm.get('km')?.touched" class="text-red-500">
            <small *ngIf="vehicleForm.get('km')?.errors?.['required']"> Ingresa el kilometraje </small>
          </div>
        </div>

        <div class="half w-full md:w-1/2">
          <input type="text" formControlName="plate" placeholder="placa" class="form-input ltr:pl-10 rtl:pr-10" />
          <div *ngIf="vehicleForm.get('plate')?.invalid && vehicleForm.get('plate')?.touched" class="text-red-500">
            <small *ngIf="vehicleForm.get('plate')?.errors?.['required']"> Ingresa la placa </small>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap md:flex-nowrap gap-4">
        <div class="half w-full md:w-1/2 pt-4">
          <input type="text" formControlName="year" placeholder="Año" class="form-input ltr:pl-10 rtl:pr-10" />
          <div *ngIf="vehicleForm.get('year')?.invalid && vehicleForm.get('year')?.touched" class="text-red-500">
            <small *ngIf="vehicleForm.get('year')?.errors?.['required']"> Ingresa el año </small>
          </div>
        </div>

        <div class="half w-full md:w-1/2 pt-4">
          <select formControlName="country" (change)="onPaisChange()" class="form-input ltr:pl-10 rtl:pr-10">
            <option value="" disabled selected>Selecciona el país</option>
            <option *ngFor="let country of countries" [value]="country.cca2">{{ country.name.common }}</option>
          </select>
          <div *ngIf="vehicleForm.get('country')?.invalid && vehicleForm.get('country')?.touched" class="text-red-500">
            <small *ngIf="vehicleForm.get('country')?.errors?.['required']"> Selecciona el país </small>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap md:flex-nowrap gap-4">
        <div class="half w-full md:w-1/2 pt-4">
          <select formControlName="state" (change)="onStateChange()" class="form-input ltr:pl-10 rtl:pr-10" [disabled]="!states.length">
            <option value="" disabled selected>Selecciona el departamento</option>
            <option *ngFor="let state of states" [value]="state.state_code">{{ state.state_name }}</option>
          </select>
          <div *ngIf="vehicleForm.get('state')?.invalid && vehicleForm.get('state')?.touched" class="text-red-500">
            <small *ngIf="vehicleForm.get('state')?.errors?.['required']"> Selecciona el departamento </small>
          </div>
        </div>

        <div class="half w-full md:w-1/2 pt-4">
          <select formControlName="city" class="form-input ltr:pl-10 rtl:pr-10" [disabled]="!cities.length">
            <option value="" disabled selected>Selecciona la ciudad</option>
            <option *ngFor="let city of cities" [value]="city.city_code">{{ city.city_name }}</option>
          </select>
          <div *ngIf="vehicleForm.get('city')?.invalid && vehicleForm.get('city')?.touched" class="text-red-500">
            <small *ngIf="vehicleForm.get('city')?.errors?.['required']"> Selecciona la ciudad </small>
          </div>
        </div>
      </div>

      <div class="relative mb-4 mt-4">
        <input type="text" id="color" formControlName="color" readonly placeholder="Selecciona el color de tu vehiculo" class="form-input cursor-pointer" />
        <p class="text-xs text-gray-500 mt-1">Haz clic en un círculo para seleccionar el color</p>
        <div class="flex gap-2 mt-2">
          <button
            type="button"
            (click)="selectColor('ROJO')"
            [ngClass]="{ 'ring-2 ring-offset-2 ring-blue-500 border border-primary': vehicleForm.get('color')?.value === 'ROJO' }"
            class="w-8 h-8 rounded-full bg-red-500"
          ></button>
          <button
            type="button"
            (click)="selectColor('VERDE')"
            [ngClass]="{ 'ring-2 ring-offset-2 ring-blue-500': vehicleForm.get('color')?.value === 'VERDE' }"
            class="w-8 h-8 rounded-full bg-green-500 border border-primary"
          ></button>
          <button
            type="button"
            (click)="selectColor('AMARILLO')"
            [ngClass]="{ 'ring-2 ring-offset-2 ring-blue-500': vehicleForm.get('color')?.value === 'AMARILLO' }"
            class="w-8 h-8 rounded-full bg-yellow-500 border border-primary"
          ></button>
          <button
            type="button"
            (click)="selectColor('AZUL')"
            [ngClass]="{ 'ring-2 ring-offset-2 ring-blue-500': vehicleForm.get('color')?.value === 'AZUL' }"
            class="w-8 h-8 rounded-full bg-blue-500 border border-primary"
          ></button>
          <button
            type="button"
            (click)="selectColor('NEGRO')"
            [ngClass]="{ 'ring-2 ring-offset-2 ring-blue-500': vehicleForm.get('color')?.value === 'NEGRO' }"
            class="w-8 h-8 rounded-full bg-black border border-primary"
          ></button>
          <button
            type="button"
            (click)="selectColor('BLANCO')"
            [ngClass]="{ 'ring-2 ring-offset-2 ring-blue-500': vehicleForm.get('color')?.value === 'BLANCO' }"
            class="w-8 h-8 rounded-full bg-white border border-primary"
          ></button>
        </div>
      </div>

      <div class="flex justify-end gap-2 mt-4">
        <button type="submit" class="btn btn-primary px-4 py-2" [disabled]="vehicleForm.invalid">Actualizar</button>
        <button type="button" class="btn btn-secondary px-4 py-2" (click)="close.emit()">Cancelar</button>
      </div>
    </form>
  </div>
</div>
